import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import Loader from 'components/common/Loader';

const DeleteConfirmationAlert = (props) => {
  const {
    toggleAlert,
    onConfirm,
    onCancel,
    message,
    confirmButton = true,
    open = false,
    addButtonLabel = 'Confirm',
    cancelButtonLabel = 'Cancel',
    title = 'Add record',
    confirmButtonColor = 'danger',
    loading = false,
  } = props;
  return (
    <Modal centered isOpen={open} toggle={toggleAlert}>
      <ModalHeader toggle={toggleAlert} className="d-none">
        {title}
      </ModalHeader>
      <ModalBody>
        <p className="f-18 mb-0 text-center py-2">{message}</p>
      </ModalBody>
      <ModalFooter className="justify-content-center py-3 pt-0 border-0">
        <Button
          color="secondary"
          outline
          size="sm"
          className="mw-100"
          onClick={onCancel}
        >
          {cancelButtonLabel}
        </Button>
        {confirmButton && (
          <Button
            color={confirmButtonColor}
            size="sm"
            className="mw-100"
            onClick={onConfirm}
          >
            {loading ? <Loader size="sm" /> : addButtonLabel}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

DeleteConfirmationAlert.propTypes = {
  open: PropTypes.bool,
  addButtonLabel: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  toggleAlert: PropTypes.func,
};
export default DeleteConfirmationAlert;
